<template>
    <ElevatedCard :widthType="WidthType.third">
        <HeaderWidget
            :iconUrl="loadIcon"
            :mode-edition="true"
            :sizeIcon="35"
            :subtitle="$t('requestInterventionWidget.subtitle')"
            :title="widget.libelle"
            @dupliquer="dupliquer"
            @filtre="filtre"
            @suppression="suppression"
        />
        <div>
            <span v-if="widget.sites == null || widget.sites.length > 1" class="site-widget">{{
                $t('multisites')
            }}</span>
            <span v-for="site in widget.sites" v-else :key="site.id" class="site-widget">
                {{ site.description }}
                <span v-if="site.id !== widget.sites[widget.sites.length - 1].id">, </span>
            </span>
        </div>
        <div class="content-container">
            <div id="chart" class="chart-width">
                <PieChart
                    :key="isLoading"
                    :colors="[getColorEnCours(), getColorPlanifie(), getColorNonPlanifie()]"
                    :isLoading="false"
                    :isPercentage="false"
                    :labels="[
                        $t('requestInterventionWidget.inProgress'),
                        $t('requestInterventionWidget.planned'),
                        $t('requestInterventionWidget.unplanned'),
                        $t('requestInterventionWidget.traitees'),
                    ]"
                    :seriesValues="series"
                    :showDataLabels="true"
                    :showLegend="true"
                    @dataPointClicked="naviguerVersRecherche"
                />
            </div>
        </div>
    </ElevatedCard>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import HeaderWidget from '@/components/ui-components/HeaderWidget.vue';
import ElevatedCard, { WidthType } from '@/components/ui-components/ElevatedCard.vue';
import { Widget } from '@/models/Widget';
import PieChart from '@/components/ui-components/PieChart.vue';

export default defineComponent({
    name: 'EditionDemandeIntervention',
    components: { PieChart, HeaderWidget, ElevatedCard },
    props: {
        widget: { type: Object as PropType<Widget>, required: true },
    },
    setup() {
        return {
            WidthType,
        };
    },
    data() {
        return {
            series: [10, 20, 30],
        };
    },
    computed: {
        loadIcon() {
            return require('@/assets/img/menu/wheel.png');
        },
    },
    methods: {
        getColorEnCours() {
            return getComputedStyle(document.documentElement).getPropertyValue('--edition-clair');
        },
        getColorPlanifie() {
            return getComputedStyle(document.documentElement).getPropertyValue('--edition-medium');
        },
        getColorNonPlanifie() {
            return getComputedStyle(document.documentElement).getPropertyValue('--edition-fonce');
        },
        filtre() {
            this.$emit('filtre');
        },
        dupliquer() {
            this.$emit('dupliquer');
        },
        suppression() {
            this.$emit('suppression');
        },
    },
});
</script>

<style scoped>
.content-container {
    background-color: var(--white);
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 0 20px;
}
@media screen and (max-height: 800px) {
    .content-container {
        height: 73%;
    }
}
</style>
